module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade modal-andriod",
    attrs: {
      "id": "pay-order",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    class: [
      'modal-dialog',
      {
        'trier-update-dialog': _vm.show.paymentMethods && _vm.currentPackage.can_subscribe && this.userRole === 'trier' && _vm.currentPackage.is_update
      },
      {
        'support-subscribe-dialog': _vm.show.paymentMethods && _vm.currentPackage.can_subscribe
      },
      {
        'not-support-subscribe-dialog': _vm.show.paymentMethods && !_vm.currentPackage.can_subscribe
      },
      {
        'update-dialog': _vm.show.paymentMethods && _vm.currentPackage.is_update
      },
      {
        'wechatPay-dialog': _vm.show.wechatPay
      },
      {
        'airwallex-dialog': _vm.show.airwallexIframe
      }
    ],
    attrs: {
      "role": "document"
    }
  }, [(_vm.show.paymentMethods) ? _c('div', {
    staticClass: "modal-content",
    attrs: {
      "id": "payment-methods"
    }
  }, [_c('modal-header'), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('h4', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('checkout')))]), _vm._v(" "), _c('p', {
    staticClass: "little-title"
  }, [_vm._v(_vm._s(_vm.$t('purchasePackage')))]), _vm._v(" "), _c('p', {
    class: {
      'valid-trier': _vm.validTrier
    }
  }, [(_vm.trierUpdate || _vm.othersUserUpdate) ? [_c('span', {
    staticClass: "upgrade-name pc-show"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('upgrade')) + " " + _vm._s(_vm.user.value_of_expire_in) + " " + _vm._s(_vm.$tc(_vm.user.unit_of_expire_in, _vm.user.value_of_expire_in)) + " - " + _vm._s(_vm.$t('type.' + _vm.currentPackage.type)) + " - " + _vm._s(_vm.currentPackage.device_count) + " " + _vm._s(_vm.$tc('devices', _vm.topupOrder.order_detail.device_count)) + "\n              "), _c('br'), _vm._v("\n              " + _vm._s(_vm.$t('priceDifference')) + "\n            ")]), _vm._v(" "), _c('span', {
    staticClass: "upgrade-name phone-show"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('upgrade')) + " " + _vm._s(_vm.user.value_of_expire_in) + " " + _vm._s(_vm.$tc(_vm.user.unit_of_expire_in, _vm.user.value_of_expire_in)) + "\n              "), _c('br'), _vm._v("\n              " + _vm._s(_vm.$t('type.' + _vm.currentPackage.type)) + " - " + _vm._s(_vm.currentPackage.device_count) + " " + _vm._s(_vm.$tc('devices', _vm.topupOrder.order_detail.device_count)) + "\n              "), _c('br'), _vm._v("\n              " + _vm._s(_vm.$t('priceDifference')) + "\n            ")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.$t(_vm.currentPackage.currency_code)) + " " + _vm._s(_vm.subTotal))])] : [_c('span', [_vm._v(_vm._s(_vm.currentPackage.device_count) + " " + _vm._s(_vm.$tc('devices', _vm.topupOrder.order_detail.device_count)) + " " + _vm._s(_vm.currentPackage.name))]), _vm._v(" "), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.$t(_vm.currentPackage.currency_code)) + " " + _vm._s(_vm.currentPackage.price))])]], 2)]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.show.loading),
      expression: "!show.loading"
    }],
    staticClass: "p-t-b-15",
    class: ['choose-methods', {
      'stripe': _vm.show.stripePay
    }]
  }, [_vm._v(_vm._s(_vm.$t('chooseMethods')))]), _vm._v(" "), (_vm.show.loading) ? _c('spinner', {
    attrs: {
      "show": _vm.show.loading && !_vm.loadPaymentMethodsFail
    }
  }) : _vm._e(), _vm._v(" "), (_vm.loadPaymentMethodsFail) ? _c('div', {
    class: ['load-fail-btn', _vm.isIE11 ? 'ie-style' : ''],
    on: {
      "click": _vm.getPaymentMethods
    }
  }, [_c('button', [_vm._v(_vm._s(_vm.$t('loadFail')))])]) : _vm._e(), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.show.loading),
      expression: "!show.loading"
    }],
    staticClass: "methods-icon-list"
  }, _vm._l((_vm.paymentMethods), function(item, index) {
    return _c('a', {
      key: index,
      class: ['methods text-center', {
        'current-method': item.id === _vm.currentPaymentMethod.id && item.channel_id === _vm.currentPaymentMethod.channel_id
      }],
      attrs: {
        "href": "javascript:void(0)",
        "title": item.channel_name || item.name
      },
      on: {
        "click": function($event) {
          return _vm.choosePaymentMethod(item)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.icon,
        "alt": item.channel_name || item.name
      }
    })])
  }), 0), _vm._v(" "), (_vm.show.stripePay) ? _c('div', {
    attrs: {
      "id": "stripe-container"
    }
  }, [_c('h5', [_vm._v(_vm._s(_vm.$t('cardDetails')))]), _vm._v(" "), _c('stripe', {
    attrs: {
      "hanlderNameError": function ($event) { return _vm.cardName = $event; },
      "isSubscribe": _vm.isSubscribe
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showSubscribeOption) ? _c('p', {
    class: ['choose-subscribe', {
      'not-support-subscribe': !_vm.supportSubscribe
    }]
  }, [_c('span', [_c('span', {
    staticClass: "check-box",
    on: {
      "click": _vm.changeSubscribeStatus
    }
  }, [(_vm.isSubscribe) ? _c('img', {
    attrs: {
      "src": "/static/img/dashboard/agree_2x.png"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isSubscribe) ? _c('span', {
    staticClass: "circle-span"
  }) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "subscribe-desc"
  }, [_vm._v(_vm._s(_vm.subscribeDescribe()))])])]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "trier-subscribe-notice text-center"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.validTrierSubscribe),
      expression: "validTrierSubscribe"
    }]
  }, [_vm._v(_vm._s(_vm.$t('trierSubscribeNotice')))])]), _vm._v(" "), _c('p', [(_vm.currentPaymentMethod.id == 'alipay_global') ? _c('router-link', {
    class: ['form-submit', _vm.disabled ? 'disabled' : ''],
    attrs: {
      "to": '/dashboard?lang=' + _vm.currentLang,
      "target": "_blank",
      "disabled": _vm.disabled
    },
    nativeOn: {
      "click": function($event) {
        return _vm.webAlipay()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('payNow')))]) : (_vm.currentPaymentMethod.id == 'mugglepay') ? _c('router-link', {
    class: ['form-submit', _vm.disabled ? 'disabled' : ''],
    attrs: {
      "to": '/dashboard?lang=' + _vm.currentLang,
      "target": "_blank",
      "disabled": _vm.disabled
    },
    nativeOn: {
      "click": function($event) {
        return _vm.mugglepay()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('payNow')))]) : (_vm.currentPaymentMethod.id == 'paypal') ? _c('router-link', {
    class: ['form-submit', _vm.disabled ? 'disabled' : ''],
    attrs: {
      "to": '/dashboard?lang=' + _vm.currentLang,
      "target": "_blank",
      "disabled": _vm.disabled
    },
    nativeOn: {
      "click": function($event) {
        return _vm.paypalPay()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('payNow')))]) : (_vm.currentPaymentMethod.id == 'paymentwall') ? _c('router-link', {
    class: ['form-submit', _vm.disabled ? 'disabled' : ''],
    attrs: {
      "to": '/dashboard?lang=' + _vm.currentLang,
      "target": "_blank",
      "disabled": _vm.disabled
    },
    nativeOn: {
      "click": function($event) {
        return _vm.paymentwallPay()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('payNow')))]) : (_vm.currentPaymentMethod.id == 'airwallex' && _vm.isMacSafari) ? _c('router-link', {
    class: ['form-submit', _vm.disabled ? 'disabled' : ''],
    attrs: {
      "to": '/dashboard?lang=' + _vm.currentLang,
      "target": "_blank",
      "disabled": _vm.disabled
    },
    nativeOn: {
      "click": function($event) {
        return _vm.paymentwallPay()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('payNow')))]) : (_vm.currentPaymentMethod.id == 'airwallex' && !_vm.isMacSafari) ? _c('button', {
    class: ['form-submit', _vm.disabled ? 'disabled' : ''],
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": function($event) {
        return _vm.airwallex()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('payNow')))]) : _c('button', {
    staticClass: "form-submit",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.topup
    }
  }, [_vm._v(_vm._s(_vm.$t('payNow')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "purchase-tips text-center"
  }, [_vm._v("*" + _vm._s(_vm.$t('purchase_tips')))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.show.wechatPay) ? _c('div', {
    staticClass: "modal-content",
    attrs: {
      "id": "wechat-qrcode"
    }
  }, [_c('modal-header'), _vm._v(" "), _c('spinner', {
    staticClass: "spinner",
    attrs: {
      "show": _vm.show.loading
    }
  }), _vm._v(" "), (!_vm.show.loading) ? _c('div', {
    staticClass: "modal-body text-center"
  }, [_c('div', {
    staticClass: "qr-code"
  }, [_c('qr-code', {
    attrs: {
      "text": _vm.qrText,
      "size": 240
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "scan-description"
  }, [_vm._v(_vm._s(_vm.$t('wechatPay')))])]) : _vm._e(), _vm._v(" "), (!_vm.show.loading) ? _c('div', {
    staticClass: "modal-footer"
  }, [_c('p', {
    staticClass: "price"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('paymentAmount')) + "\n          "), _c('span', [_vm._v(_vm._s(_vm.$t(_vm.currentSymbol)) + _vm._s(_vm.subTotal))])])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.show.airwallexIframe) ? _c('div', {
    staticClass: "modal-content",
    attrs: {
      "id": "airwallex-iframe"
    }
  }, [_c('svg', {
    staticClass: "icon close",
    on: {
      "click": function($event) {
        return _vm.airwallexClose()
      }
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-close"
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show.loading),
      expression: "show.loading"
    }],
    staticClass: "loading-box"
  }, [_c('spinner', {
    staticClass: "spinner",
    attrs: {
      "show": _vm.show.loading
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('redirect')) + _vm._s(_vm.$t('airwallex')) + _vm._s(_vm.$t('wait')))])], 1), _vm._v(" "), _c('iframe', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.show.loading),
      expression: "!show.loading"
    }],
    attrs: {
      "id": "iframe",
      "src": _vm.airwallexIframe_url,
      "frameborder": "0",
      "scrolling": "no",
      "width": "100%",
      "height": "100%"
    }
  }), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.show.loading),
      expression: "!show.loading"
    }],
    staticClass: "payCompleted",
    on: {
      "click": function($event) {
        return _vm.airwallexClose()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('payCompleted')))])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-288e1bf6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/payOrder/IndexMain.vue
// module id = 1287
// module chunks = 1